<template>
  <form @submit.prevent="$emit('submit')" class="white-box p30">
    <div class="row">
      <div class="col-sm-6">
        <FieldMedia name="Attach file" :rules="typeof value.attachment_solution === 'string' ? '' : 'required'" type="pdf,image" v-model="value.attachment_solution" :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <FieldTextArea name="Description" rules="required" v-model="value.tmp_solution" :disabled="disabled" />
      </div>
    </div>
    <div v-if="!disabled" class="d-flex justify-content-center">
      <button class="btn btn-orange" type="submit">Save</button>
    </div>
  </form>
</template>
<script>
import FieldMedia from '@/components/field/Media.vue';
import FieldTextArea from '@/components/field/TextArea.vue';

export default {
  name: "FormFeedbackTemporarySolution",
  components: {
    FieldTextArea,
    FieldMedia
  },
  props: ['value', 'disabled'],
}
</script>
